export default __webpack_public_path__ + "static/media/attach-icon.c9db657d.svg";